(function ($, Drupal) {
  Drupal.behaviors.backgroundVideoResize = {
    attach: function (context, settings) {

      function resizeVideo() {
          let player = $('.background-video--wrapper video, .background-video--iframe', context);
          if (player.length === 0) return;

          let ratio = 1.78;
          let window_ratio = window.innerWidth / window.innerHeight;

          if(window_ratio < ratio){
            player.css({
              width: 'auto',
              height: 'auto',
              'min-width': (window.innerHeight * ratio)+'px',
              'min-height': 'calc(100vh - 120px)',
              'margin-top': '0',
              'margin-left': '-'+((window.innerHeight * ratio) - window.innerWidth)/2 +'px',
            })
          } else {
            player.css({
              width: 'auto',
              height: 'auto',
              'min-width': '100%',
              'min-height': (window.innerWidth / window_ratio)+'px',
              'margin-top': '-120px',
              'margin-left' : '0',
            })
          }
          player.attr('width', player.width() + 'px');
          player.attr('height', player.height()+ 'px');
      }
      
      // Ejecutar al cargar el contexto (normalmente al cargar página o al insertar vía AJAX)
     // resizeVideo();

      // Ejecutar al redimensionar ventana
    /*  $(window).on('resize.backgroundVideoResize', function () {
        resizeVideo();
      });*/

      console.log('video')

    }
  };
})(jQuery, Drupal);